import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTubeOrProfileCuttingSm = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 100 100",
	style: { enableBackground: "new 0 0 100 100" },
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("g", {
			style: {},
			children: /* @__PURE__ */ _jsx("path", {
				className: "icon-white",
				d: "M88.1,60.8c0-0.1-0.1-0.1-0.2-0.1l-58.8-34c-0.1,0-0.1-0.1-0.2-0.1c-2.3-1.2-5.3-0.8-8.5,1v0 c-1.4,0.8-2.8,1.9-4.1,3.2C11.7,35.4,8.6,42.3,8.6,48c0,3.8,1.4,6.7,3.8,8l27.2,15.7c0,0,0,0,0,0c0,0,0.1,0,0.1,0.1c0,0,0,0,0,0 l11.7,6.8l0.2,0.1v0c0,0,0,0,0,0l0.2,0.1l1.9,1.1l7.4,4.3l0.2,0.1c0,0,0,0,0,0l9.6,5.5c0,0,0,0,0,0c0.1,0,0.1,0.1,0.2,0.1 c0,0,0,0,0,0c0.9,0.5,2,0.7,3.1,0.7c1.7,0,3.6-0.6,5.5-1.7c6.5-3.7,11.8-12.9,11.8-20.3C91.8,65,90.5,62.2,88.1,60.8z"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M88.9,60.3c-0.5-0.5-1.4-0.8-2-1.2c-1.6-0.9-56.1-32.4-57.5-33.2c-3.3-1.9-7.1-1.1-10.2,0.8v0 c-6.7,4.1-11.7,12.6-12,20.4c-0.1,3.4,0.8,7.2,3.9,9.1c0.4,0.2,0.8,0.5,1.2,0.7c5.9,3.4,53.6,31,58.5,33.8 c5.7,3.2,12.1-1.5,15.7-5.9c4.4-5.3,8.3-14,5.5-20.8C91.3,62.5,90.3,61.1,88.9,60.3z M72.3,88.5c-4-2.4-2.8-9-1.5-12.5 c0.6-1.7,1.4-3.3,2.3-4.9c0.4-0.7,1.9-3,3.6-4.7c1.5-1.6,3.3-2.7,3.9-3.1c1.9-1.1,4.4-2,6.5-1c4.2,1.8,3.4,8,2.4,11.5 c-1.2,4.1-3.5,8-6.5,11C80.5,87.2,75.8,90.7,72.3,88.5z M67,84c0.1,0.6,0.2,1.1,0.3,1.6C60.7,81.8,39.9,70,39.2,69 c-2.4-3-1.5-7.9-0.4-11.2c0.7-2.1,1.7-4,2.8-5.8c0.6-0.9,1.2-1.7,1.9-2.6c0.5-0.6,1.6-1.4,1.8-2.2c0.3-1.1-0.8-1.9-1.8-1.5 c-0.6,0.2-1.2,1.1-1.7,1.6c-1.6,1.9-3,3.9-4.1,6.1c-2.1,4.2-3.5,9.3-2.3,13.9c-6.7-3.9-13.4-7.8-20.2-11.6c-0.9-0.5-1.8-1-2.7-1.6 c-2.8-1.7-3.1-5.3-2.7-8.3c0.5-4,2.2-7.8,4.5-11c2.4-3.3,6-6.9,10.2-7.3c2.3-0.2,4.1,1.2,5.9,2.2c3.1,1.8,46.1,26.6,51.6,29.8 c0.1,0.1,0.2,0.1,0.3,0.2c-4.4,1.2-8.1,4.7-10.7,8.4C68.7,72.5,66.4,78.4,67,84z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M66.6,58.4c-2.8-1.6-5.5-3.2-8.3-4.8c-1.5-0.9-2.4-1.6-3.9-0.1C52.1,56,50.3,58.9,49,62 c-0.6,1.4-1.1,2.9-1.4,4.4c-0.3,1.3-0.9,3.3-0.5,4.6c0.3,1.1,2.2,1.7,3.1,2.2c1.8,1,3.5,2,5.3,3.1c0.9,0.5,2.5,1.9,3.6,1.3 c1.1-0.6,0.8-3.4,1-4.5c0.4-1.8,1-3.6,1.8-5.3c0.8-1.8,1.8-3.4,3-5C65.6,61.8,68.5,59.5,66.6,58.4z M57.8,75 c-0.2,0.1-0.3,0.2-0.5,0.2l-7.8-4.5c0.2-5.5,2.9-11.1,6.6-15.2l0,0c0.2-0.2,0.4-0.4,0.6-0.6c1.2,0.7,7.5,4.1,7.9,4.6 c0.4,0.5-0.2,0.7-0.7,1.3c-1.2,1.4-2.2,3-3.1,4.6C59.2,68.3,58.1,71.6,57.8,75z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M44.8,10.9c0.7,0,1.2-0.5,1.2-1.2V7.7c0-0.7-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2v1.9 C43.6,10.3,44.2,10.9,44.8,10.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M44.8,41.8c0.7,0,1.2-0.5,1.2-1.2v-3.9c0-0.7-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2v3.9 C43.6,41.3,44.2,41.8,44.8,41.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M44.8,26.3c0.7,0,1.2-0.5,1.2-1.2v-3.9c0-0.7-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2v3.9 C43.6,25.8,44.2,26.3,44.8,26.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M44.8,18.6c0.7,0,1.2-0.5,1.2-1.2v-3.9c0-0.7-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2v3.9 C43.6,18.1,44.2,18.6,44.8,18.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M44.8,34.1c0.7,0,1.2-0.5,1.2-1.2V29c0-0.7-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2v3.9 C43.6,33.5,44.2,34.1,44.8,34.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M44.8,47.6c0.7,0,1.2-0.5,1.2-1.2v-1.9c0-0.7-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2v1.9 C43.6,47.1,44.2,47.6,44.8,47.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M59.3,74.3c-0.2-0.3-0.5-0.4-0.9-0.4c-0.2,0-0.4,0.1-0.6,0.2l-1.7,1c-0.3,0.2-0.5,0.4-0.6,0.7 c-0.1,0.3,0,0.6,0.1,0.9c0.2,0.4,0.6,0.6,1,0.6c0.2,0,0.4-0.1,0.6-0.2l1.7-1l0,0c0.6-0.3,0.8-1.1,0.4-1.6 C59.4,74.4,59.4,74.3,59.3,74.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M46.3,80.7l-3.3,1.9c-0.6,0.3-0.8,1.1-0.4,1.6c0.2,0.4,0.6,0.6,1,0.6c0.2,0,0.4-0.1,0.6-0.2 l3.3-1.9c0.6-0.3,0.8-1.1,0.4-1.6C47.6,80.5,46.9,80.3,46.3,80.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M53.8,76.8c-0.3-0.1-0.6,0-0.9,0.1l-3.3,1.9c-0.6,0.3-0.8,1.1-0.4,1.6c0.2,0.4,0.6,0.6,1,0.6 c0.2,0,0.4-0.1,0.6-0.2l3.3-1.9c0.6-0.3,0.8-1.1,0.4-1.6C54.4,77,54.1,76.8,53.8,76.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M37.8,87.2c0.2,0.3,0.5,0.4,0.9,0.4c0.2,0,0.4-0.1,0.6-0.2l1.7-1c0.3-0.2,0.5-0.4,0.6-0.7 c0.1-0.3,0-0.6-0.1-0.9c-0.2-0.4-0.6-0.6-1-0.6c-0.2,0-0.4,0.1-0.6,0.2l-1.7,1l0,0c-0.6,0.3-0.8,1.1-0.4,1.6 C37.7,87.1,37.8,87.2,37.8,87.2z"
		})
	] }) })
});
export default SvgTubeOrProfileCuttingSm;
